
import { Mapper } from "../../../../../core/base";
import { DistributionLane } from "planning-portal-library/src/lib/core/domain";
import { DistributionLaneWebEntity } from "./distribution-lane-web-entity";

export class DistributionLaneWebRepositoryMapper extends Mapper<DistributionLaneWebEntity, DistributionLane> {
  mapFrom(param: DistributionLaneWebEntity): DistributionLane {
    return {
      id: param.id,
      name:param.name,
      createdAt:param.createdAt
    };
  }

  mapTo(param: DistributionLane): DistributionLaneWebEntity {
    return {
        id: param.id,
        name:param.name,
        createdAt:param.createdAt
    };
  }
}
